import { globalVariables } from "helper/globalVariables";
import { DecoratedPrice } from "helper/utility";
import { Button } from "shared/Components/button";
import { PaymentDetailModal } from "../PaymentDetailModal";
import { useRef, useState } from "react";
import Dropdown from "shared/Components/dropdown";
import Loader from "shared/Components/loader";

export const PaymentMobileCardComponent = ({ data, onChangeStatus }) => {
  const modalRef = useRef(null);
  const [statusLoading, setStatusLoading] = useState(false);

  const onChangeStatusInternal = async (option) => {
    setStatusLoading(true);
    await onChangeStatus(option);
    setStatusLoading(false);
  };

  const PaidBtnContainer = () => {
    if (data?.payment_status === "Unpaid") {
      return (
        <Dropdown
          width={"w-[120px] "}
          placeholder="Unpaid"
          dropdownOptions={[globalVariables.markAsPaid]}
          customContent="justify-center"
          type="secondary"
          mainContent="w-[120px]"
          transform="max-[380px]:translate-x-[-10%] translate-y-[0%]"
          onChange={(option) => onChangeStatusInternal(option)}
        />
      );
    }
    if (data?.payment_status === "Paid") {
      return (
        <span className="text-sm font-regular text-green max-[300px]:text-xs">
          {globalVariables.paid}
        </span>
      );
    } else {
      return (
        <span className="text-sm font-regular text-gray-700 max-[300px]:text-xs">
          {data?.payment_status}
        </span>
      );
    }
  };

  const openModal = (e) => {
    e.stopPropagation();
    modalRef.current.openModal();
  };

  return (
    <div className="max-w-md mx-auto overflow-hidden bg-white bg-opacity-50 b-bottom py-[15px] border-b-[1px] border-gray-100">
      <div className="flex px-5 justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-800 max-[300px]:text-sm">
            {globalVariables.ownerName}: {data.owner_name}
          </h2>
          <div className="flex items-center py-1">
            <p className="text-xs text-gray-700">{globalVariables.dogName}: </p>
            <p className="text-sm text-gray-600 ml-1 max-[300px]:text-xs">
              {data?.call_name}
            </p>
          </div>
        </div>
        {statusLoading ? (
          <div className="w-[50px] my-[5px]">
            <Loader />
          </div>
        ) : (
          <div
            className={`bg-gray-300 text-xs text-center font-medium rounded-full py-[5px] px-[10px] border min-w-[120px] ${
              data.markAsPaid
                ? "border-green bg-white"
                : "border-gray-300 bg-white"
            }`}
            style={{
              height: "max-content",
            }}
          >
            <PaidBtnContainer />
          </div>
        )}
      </div>
      <div className="px-5 mt-2 flex justify-between">
        <div className="flex items-center py-1">
          <p className="text-sm text-gray-700 max-[300px]:text-xs">
            {globalVariables.amount}:{" "}
          </p>
          <p className="text-sm text-gray-600 ml-1 max-[300px]:text-xs">
            {DecoratedPrice(data?.amount)}
          </p>
        </div>
        <Button
          width="w-[130px] max-[300px]:w-[110px]"
          label={globalVariables.viewMore}
          onClick={openModal}
        />
      </div>
      <PaymentDetailModal
        ref={modalRef}
        data={data}
        onChangeStatus={(option) => onChangeStatusInternal(option)}
        statusLoading={statusLoading}
      />
    </div>
  );
};
